var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessengerBl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1680_7721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.000990662 11.639C0.000990662 4.949 5.24099 0 12.001 0C18.761 0 24 4.95 24 11.639C24 18.328 18.76 23.277 12 23.277C10.79 23.277 9.61999 23.117 8.52999 22.817C8.31724 22.7597 8.09127 22.7774 7.88999 22.867L5.49999 23.917C5.35592 23.9811 5.19826 24.0088 5.04096 23.9975C4.88366 23.9862 4.73156 23.9364 4.59811 23.8523C4.46466 23.7683 4.35396 23.6527 4.2758 23.5157C4.19764 23.3788 4.15443 23.2246 4.14999 23.067L4.07999 20.927C4.07457 20.7981 4.04347 20.6715 3.98852 20.5548C3.93357 20.438 3.85588 20.3334 3.75999 20.247C2.55761 19.162 1.60047 17.8331 0.952433 16.3489C0.3044 14.8647 -0.0196203 13.2593 0.00199066 11.64L0.000990662 11.639ZM8.32099 9.449L4.80099 15.049C4.45099 15.579 5.12099 16.188 5.62099 15.799L9.41099 12.929C9.67099 12.729 10.011 12.729 10.281 12.929L13.081 15.029C13.921 15.659 15.121 15.429 15.681 14.549L19.201 8.949C19.551 8.419 18.881 7.819 18.381 8.199L14.591 11.069C14.341 11.269 13.991 11.269 13.731 11.069L10.931 8.969C10.7319 8.81858 10.5037 8.7112 10.2608 8.65369C10.018 8.59618 9.76585 8.58979 9.52041 8.63492C9.27498 8.68006 9.04161 8.77574 8.83513 8.91588C8.62865 9.05603 8.45356 9.23758 8.32099 9.449Z",
    fill: "#2C2C2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1680_7721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerBl);
export default __webpack_public_path__ + "static/media/MessengerBl.5a082ab7ed5f5a1295b4c8fc0d12a36b.svg";
export { ForwardRef as ReactComponent };